const HERE_KEY = process.env.REACT_APP_HERE_TOKEN;
const HERE_BASE = 'https://router.hereapi.com/v8/routes';

// City bounding polygons grouped by country — used for map visualisation and avoid-area routing
export const URBAN_AREAS_BY_COUNTRY = {
  'Portugal': {
    'Lisboa':      [[-9.28,38.68],[-8.98,38.68],[-8.98,38.88],[-9.28,38.88],[-9.28,38.68]],
    'Porto':       [[-8.72,41.12],[-8.54,41.12],[-8.54,41.22],[-8.72,41.22],[-8.72,41.12]],
    'Coimbra':     [[-8.50,40.18],[-8.38,40.18],[-8.38,40.26],[-8.50,40.26],[-8.50,40.18]],
    'Braga':       [[-8.47,41.51],[-8.38,41.51],[-8.38,41.58],[-8.47,41.58],[-8.47,41.51]],
    'Setúbal':     [[-8.94,38.50],[-8.87,38.50],[-8.87,38.55],[-8.94,38.55],[-8.94,38.50]],
    'Faro':        [[-8.02,37.00],[-7.90,37.00],[-7.90,37.07],[-8.02,37.07],[-8.02,37.00]],
    'Aveiro':      [[-8.66,40.62],[-8.63,40.62],[-8.63,40.66],[-8.66,40.66],[-8.66,40.62]],
    'Évora':       [[-7.92,38.56],[-7.89,38.56],[-7.89,38.59],[-7.92,38.59],[-7.92,38.56]],
    'Guimarães':   [[-8.32,41.43],[-8.29,41.43],[-8.29,41.46],[-8.32,41.46],[-8.32,41.43]],
    'Leiria':      [[-8.82,39.73],[-8.79,39.73],[-8.79,39.76],[-8.82,39.76],[-8.82,39.73]],
    'Viseu':       [[-7.93,40.65],[-7.89,40.65],[-7.89,40.68],[-7.93,40.68],[-7.93,40.65]],
  },
  'Espanha': {
    'Madrid':      [[-3.88,40.32],[-3.55,40.32],[-3.55,40.57],[-3.88,40.57],[-3.88,40.32]],
    'Barcelona':   [[ 2.05,41.32],[ 2.28,41.32],[ 2.28,41.48],[ 2.05,41.48],[ 2.05,41.32]],
    'Sevilla':     [[-6.05,37.30],[-5.93,37.30],[-5.93,37.44],[-6.05,37.44],[-6.05,37.30]],
    'Bilbao':      [[-3.00,43.24],[-2.87,43.24],[-2.87,43.32],[-3.00,43.32],[-3.00,43.24]],
    'Valencia':    [[-0.43,39.44],[-0.30,39.44],[-0.30,39.52],[-0.43,39.52],[-0.43,39.44]],
    'Zaragoza':    [[-1.02,41.63],[-0.86,41.63],[-0.86,41.69],[-1.02,41.69],[-1.02,41.63]],
    'Málaga':      [[-4.52,36.70],[-4.41,36.70],[-4.41,36.74],[-4.52,36.74],[-4.52,36.70]],
    'Alicante':    [[-0.52,38.33],[-0.46,38.33],[-0.46,38.37],[-0.52,38.37],[-0.52,38.33]],
    'Valladolid':  [[-4.78,41.62],[-4.70,41.62],[-4.70,41.67],[-4.78,41.67],[-4.78,41.62]],
    'San Sebastián':[[-2.01,43.29],[-1.93,43.29],[-1.93,43.34],[-2.01,43.34],[-2.01,43.29]],
    'Burgos':      [[-3.73,42.32],[-3.68,42.32],[-3.68,42.37],[-3.73,42.37],[-3.73,42.32]],
    'Vigo':        [[-8.77,42.21],[-8.71,42.21],[-8.71,42.26],[-8.77,42.26],[-8.77,42.21]],
  },
  'França': {
    'Paris':       [[ 2.25,48.81],[ 2.47,48.81],[ 2.47,48.91],[ 2.25,48.91],[ 2.25,48.81]],
    'Lyon':        [[ 4.81,45.73],[ 4.87,45.73],[ 4.87,45.80],[ 4.81,45.80],[ 4.81,45.73]],
    'Marseille':   [[ 5.34,43.27],[ 5.41,43.27],[ 5.41,43.33],[ 5.34,43.33],[ 5.34,43.27]],
    'Toulouse':    [[ 1.40,43.57],[ 1.48,43.57],[ 1.48,43.63],[ 1.40,43.63],[ 1.40,43.57]],
    'Bordeaux':    [[-0.62,44.80],[-0.54,44.80],[-0.54,44.87],[-0.62,44.87],[-0.62,44.80]],
    'Lille':       [[ 3.03,50.61],[ 3.08,50.61],[ 3.08,50.65],[ 3.03,50.65],[ 3.03,50.61]],
    'Strasbourg':  [[ 7.72,48.56],[ 7.78,48.56],[ 7.78,48.60],[ 7.72,48.60],[ 7.72,48.56]],
    'Nantes':      [[-1.63,47.19],[-1.53,47.19],[-1.53,47.25],[-1.63,47.25],[-1.63,47.19]],
    'Nice':        [[ 7.24,43.69],[ 7.31,43.69],[ 7.31,43.73],[ 7.24,43.73],[ 7.24,43.69]],
    'Montpellier': [[ 3.84,43.59],[ 3.91,43.59],[ 3.91,43.64],[ 3.84,43.64],[ 3.84,43.59]],
    'Rennes':      [[-1.73,48.10],[-1.65,48.10],[-1.65,48.14],[-1.73,48.14],[-1.73,48.10]],
    'Grenoble':    [[ 5.69,45.16],[ 5.76,45.16],[ 5.76,45.21],[ 5.69,45.21],[ 5.69,45.16]],
    'Dijon':       [[ 5.02,47.31],[ 5.07,47.31],[ 5.07,47.35],[ 5.02,47.35],[ 5.02,47.31]],
  },
  'Bélgica': {
    'Bruxelas':    [[ 4.31,50.82],[ 4.43,50.82],[ 4.43,50.90],[ 4.31,50.90],[ 4.31,50.82]],
    'Antuérpia':   [[ 4.38,51.20],[ 4.44,51.20],[ 4.44,51.24],[ 4.38,51.24],[ 4.38,51.20]],
    'Liège':       [[ 5.56,50.62],[ 5.61,50.62],[ 5.61,50.66],[ 5.56,50.66],[ 5.56,50.62]],
    'Gent':        [[ 3.69,51.03],[ 3.74,51.03],[ 3.74,51.07],[ 3.69,51.07],[ 3.69,51.03]],
    'Bruges':      [[ 3.21,51.19],[ 3.25,51.19],[ 3.25,51.22],[ 3.21,51.22],[ 3.21,51.19]],
  },
  'Países Baixos': {
    'Amsterdão':   [[ 4.75,52.32],[ 5.03,52.32],[ 5.03,52.43],[ 4.75,52.43],[ 4.75,52.32]],
    'Roterdão':    [[ 4.38,51.87],[ 4.56,51.87],[ 4.56,51.97],[ 4.38,51.97],[ 4.38,51.87]],
    'Haia':        [[ 4.22,52.04],[ 4.38,52.04],[ 4.38,52.12],[ 4.22,52.12],[ 4.22,52.04]],
    'Utrecht':     [[ 5.07,52.07],[ 5.16,52.07],[ 5.16,52.12],[ 5.07,52.12],[ 5.07,52.07]],
    'Eindhoven':   [[ 5.44,51.42],[ 5.50,51.42],[ 5.50,51.47],[ 5.44,51.47],[ 5.44,51.42]],
  },
  'Luxemburgo': {
    'Luxemburgo':  [[ 6.10,49.58],[ 6.17,49.58],[ 6.17,49.63],[ 6.10,49.63],[ 6.10,49.58]],
  },
  'Alemanha': {
    'Berlim':      [[13.27,52.45],[13.57,52.45],[13.57,52.58],[13.27,52.58],[13.27,52.45]],
    'Hamburgo':    [[ 9.82,53.44],[10.11,53.44],[10.11,53.65],[ 9.82,53.65],[ 9.82,53.44]],
    'Munique':     [[11.43,48.06],[11.68,48.06],[11.68,48.22],[11.43,48.22],[11.43,48.06]],
    'Frankfurt':   [[ 8.58,50.07],[ 8.77,50.07],[ 8.77,50.16],[ 8.58,50.16],[ 8.58,50.07]],
    'Colónia':     [[ 6.88,50.87],[ 7.02,50.87],[ 7.02,50.98],[ 6.88,50.98],[ 6.88,50.87]],
    'Stuttgart':   [[ 9.12,48.73],[ 9.24,48.73],[ 9.24,48.83],[ 9.12,48.83],[ 9.12,48.73]],
    'Düsseldorf':  [[ 6.73,51.18],[ 6.86,51.18],[ 6.86,51.27],[ 6.73,51.27],[ 6.73,51.18]],
    'Dortmund':    [[ 7.40,51.48],[ 7.53,51.48],[ 7.53,51.55],[ 7.40,51.55],[ 7.40,51.48]],
    'Bremen':      [[ 8.78,53.06],[ 8.91,53.06],[ 8.91,53.13],[ 8.78,53.13],[ 8.78,53.06]],
    'Nuremberga':  [[11.02,49.43],[11.11,49.43],[11.11,49.48],[11.02,49.48],[11.02,49.43]],
    'Leipzig':     [[12.34,51.30],[12.43,51.30],[12.43,51.37],[12.34,51.37],[12.34,51.30]],
    'Hannover':    [[ 9.68,52.33],[ 9.79,52.33],[ 9.79,52.40],[ 9.68,52.40],[ 9.68,52.33]],
  },
  'Suíça': {
    'Zurique':     [[ 8.49,47.35],[ 8.61,47.35],[ 8.61,47.42],[ 8.49,47.42],[ 8.49,47.35]],
    'Genebra':     [[ 6.09,46.18],[ 6.18,46.18],[ 6.18,46.24],[ 6.09,46.24],[ 6.09,46.18]],
    'Basileia':    [[ 7.56,47.54],[ 7.65,47.54],[ 7.65,47.58],[ 7.56,47.58],[ 7.56,47.54]],
    'Berna':       [[ 7.40,46.93],[ 7.49,46.93],[ 7.49,46.97],[ 7.40,46.97],[ 7.40,46.93]],
  },
  'Áustria': {
    'Viena':       [[16.22,48.13],[16.56,48.13],[16.56,48.28],[16.22,48.28],[16.22,48.13]],
    'Salzburgo':   [[12.98,47.78],[13.08,47.78],[13.08,47.83],[12.98,47.83],[12.98,47.78]],
    'Graz':        [[15.38,47.02],[15.49,47.02],[15.49,47.09],[15.38,47.09],[15.38,47.02]],
    'Innsbruck':   [[11.35,47.25],[11.46,47.25],[11.46,47.30],[11.35,47.30],[11.35,47.25]],
  },
  'Itália': {
    'Milão':       [[ 9.15,45.44],[ 9.22,45.44],[ 9.22,45.50],[ 9.15,45.50],[ 9.15,45.44]],
    'Roma':        [[12.45,41.87],[12.52,41.87],[12.52,41.93],[12.45,41.93],[12.45,41.87]],
    'Turim':       [[ 7.65,45.05],[ 7.72,45.05],[ 7.72,45.10],[ 7.65,45.10],[ 7.65,45.05]],
    'Nápoles':     [[14.23,40.83],[14.30,40.83],[14.30,40.88],[14.23,40.88],[14.23,40.83]],
    'Génova':      [[ 8.91,44.38],[ 8.98,44.38],[ 8.98,44.44],[ 8.91,44.44],[ 8.91,44.38]],
    'Bolonha':     [[11.32,44.48],[11.36,44.48],[11.36,44.51],[11.32,44.51],[11.32,44.48]],
    'Florença':    [[11.22,43.74],[11.29,43.74],[11.29,43.80],[11.22,43.80],[11.22,43.74]],
    'Veneza':      [[12.28,45.42],[12.38,45.42],[12.38,45.47],[12.28,45.47],[12.28,45.42]],
    'Pálermo':     [[13.33,38.11],[13.38,38.11],[13.38,38.16],[13.33,38.16],[13.33,38.11]],
    'Bari':        [[16.85,41.11],[16.90,41.11],[16.90,41.14],[16.85,41.14],[16.85,41.11]],
  },
  'Angola': {
    'Luanda':        [[13.20,-9.00],[13.42,-9.00],[13.42,-8.78],[13.20,-8.78],[13.20,-9.00]],
    'Benguela':      [[13.38,-12.62],[13.44,-12.62],[13.44,-12.56],[13.38,-12.56],[13.38,-12.62]],
    'Lobito':        [[13.53,-12.39],[13.58,-12.39],[13.58,-12.35],[13.53,-12.35],[13.53,-12.39]],
    'Huambo':        [[15.73,-12.79],[15.78,-12.79],[15.78,-12.74],[15.73,-12.74],[15.73,-12.79]],
    'Malange':       [[16.31,-9.58],[16.37,-9.58],[16.37,-9.52],[16.31,-9.52],[16.31,-9.58]],
    'Cabinda':       [[12.16,-5.58],[12.22,-5.58],[12.22,-5.52],[12.16,-5.52],[12.16,-5.58]],
    'Uíge':          [[15.01,-7.64],[15.07,-7.64],[15.07,-7.58],[15.01,-7.58],[15.01,-7.64]],
    'Saurimo':       [[20.36,-9.69],[20.42,-9.69],[20.42,-9.63],[20.36,-9.63],[20.36,-9.69]],
    'Dundo':         [[20.80,-7.40],[20.86,-7.40],[20.86,-7.34],[20.80,-7.34],[20.80,-7.40]],
    'Menongue':      [[17.66,-14.69],[17.72,-14.69],[17.72,-14.63],[17.66,-14.63],[17.66,-14.69]],
    'Sumbe':         [[13.81,-11.24],[13.87,-11.24],[13.87,-11.18],[13.81,-11.18],[13.81,-11.24]],
    'Namibe':        [[12.13,-15.23],[12.19,-15.23],[12.19,-15.17],[12.13,-15.17],[12.13,-15.23]],
    'Cuito':         [[17.90,-12.41],[17.96,-12.41],[17.96,-12.35],[17.90,-12.35],[17.90,-12.41]],
    'Ondjiva':       [[15.70,-17.10],[15.76,-17.10],[15.76,-17.04],[15.70,-17.04],[15.70,-17.10]],
    'Caxito':        [[13.63,-8.61],[13.69,-8.61],[13.69,-8.55],[13.63,-8.55],[13.63,-8.61]],
    'Ndalatando':    [[14.88,-9.34],[14.94,-9.34],[14.94,-9.28],[14.88,-9.28],[14.88,-9.34]],
    'M\'Banza-Kongo':[[14.21,-6.30],[14.27,-6.30],[14.27,-6.24],[14.21,-6.24],[14.21,-6.30]],
  },
};

// Flat map for backward compatibility (used by API avoid-areas builder and map rendering)
export const URBAN_AREAS = Object.fromEntries(
  Object.values(URBAN_AREAS_BY_COUNTRY).flatMap(cities => Object.entries(cities))
);

// HERE Flexible Polyline decoder — spec: github.com/heremaps/flexible-polyline
function decodePoly(encoded) {
  const T = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
  const inv = {};
  for (let i = 0; i < T.length; i++) inv[T[i]] = i;
  let pos = 0;
  function rU() {
    let r = 0, s = 0, b;
    do { b = inv[encoded[pos++]]; r |= (b & 31) << s; s += 5; } while (b > 31);
    return r;
  }
  function rS() { const v = rU(); return (v & 1) ? ~(v >>> 1) : v >>> 1; }
  rU(); // version
  const h = rU();
  const prec = h & 15;
  const d3 = (h >> 4) & 7;
  const f = 10 ** prec;
  const pts = [];
  let la = 0, lo = 0;
  while (pos < encoded.length) {
    la += rS(); lo += rS();
    if (d3) rS(); // skip altitude
    pts.push([lo / f, la / f]); // [lng, lat] for GeoJSON
  }
  return pts;
}

function classifyRoad(label) {
  const refs = (label || '').toUpperCase().split(/[;,/]+/).map(r => r.replace(/\s+/g, '').trim()).filter(Boolean);
  const priority = { motorway: 4, highway: 3, national: 2, local: 1 };
  let best = null;
  for (const r of refs) {
    let type = null;
    if (/^A-?\d+$/.test(r) || /^AP-?\d+$/.test(r) || /^AG-?\d+$/.test(r)) type = 'motorway';
    else if (/^E-?\d+$/.test(r))                                             type = 'motorway';
    else if (/^(IP|IC)-?\d+$/.test(r))                                       type = 'highway';
    else if (/^(EN|EM|ER|CM|M|N)-?\d+/.test(r))                             type = 'national';
    if (type && priority[type] > (priority[best] || 0)) best = type;
  }
  if (best) return best;
  const n = (label || '').toUpperCase();
  if (/AUTO.?ESTRADA|AUTOPISTA|AUTOV[IÍ]A/.test(n)) return 'motorway';
  if (/ITINER[AÁ]RIO|VARIANTE/.test(n))             return 'highway';
  if (/ESTRADA (NACIONAL|MUNICIPAL|REGIONAL)/.test(n)) return 'national';
  return 'local';
}

function parseSections(sections) {
  let dist = 0, dur = 0;
  const coords = [];
  const breakdown = { motorway: 0, highway: 0, national: 0, local: 0 };
  const countryDistances = {}; // { PRT: meters, ESP: meters, ... }
  const steps = [];
  const roadSegments = []; // [{ startIdx, endIdx, type }] — for map coloring
  let prev = null;

  for (const sec of sections) {
    dist += sec.summary.length;
    dur += sec.summary.duration;
    const pts = decodePoly(sec.polyline);
    const secStart = coords.length === 0 ? 0 : coords.length - 1;
    if (coords.length) coords.push(...pts.slice(1));
    else coords.push(...pts);

    // Cumulative polyline distances — used when act.length is absent (HERE v8 optional field)
    const cumDist = [0];
    for (let i = 1; i < pts.length; i++) {
      const dLat = (pts[i][1] - pts[i-1][1]) * Math.PI / 180;
      const dLng = (pts[i][0] - pts[i-1][0]) * Math.PI / 180;
      const midLat = ((pts[i][1] + pts[i-1][1]) / 2) * Math.PI / 180;
      cumDist.push(cumDist[i-1] + Math.sqrt((dLat*6371000)**2 + (dLng*Math.cos(midLat)*6371000)**2));
    }

    // Extract country distances, road classification, and road segments from spans
    // spans contain: offset, countryCode, names[], functionalClass
    const spans = sec.spans || [];
    for (let i = 0; i < spans.length; i++) {
      const span = spans[i];
      const startOff = span.offset || 0;
      const endOff = (i + 1 < spans.length) ? (spans[i + 1].offset || 0) : pts.length - 1;
      const s = Math.min(startOff, cumDist.length - 1);
      const e = Math.min(endOff, cumDist.length - 1);
      const d = Math.max(0, cumDist[e] - cumDist[s]);

      // Country distances
      const cc = span.countryCode;
      if (cc) countryDistances[cc] = (countryDistances[cc] || 0) + d;

      // Road classification from functionalClass (HERE: 1=motorway, 2=major, 3=secondary, 4-5=local)
      // or from road name/number
      const spanNames = (span.names || []).map(n => n.value);
      const label = spanNames.join('/') || '';
      let type;
      if (span.functionalClass === 1) type = 'motorway';
      else if (span.functionalClass === 2) type = 'highway';
      else if (span.functionalClass === 3) type = 'national';
      else if (label) type = classifyRoad(label);
      else type = 'local';
      if (d > 0) breakdown[type] += d;

      // Road segments for map coloring (global coord indices)
      const gStart = secStart + Math.min(startOff, pts.length - 1);
      const gEnd = secStart + Math.min(endOff, pts.length - 1);
      if (gEnd > gStart) {
        roadSegments.push({ startIdx: gStart, endIdx: gEnd, type });
      }
    }

    // Build route steps from turnByTurnActions (have nextRoad) or actions
    const actions = sec.turnByTurnActions || sec.actions || [];
    const sectionCountry = sec.id?.split(':')[0] || '';
    for (let i = 0; i < actions.length; i++) {
      const act = actions[i];
      const road = act.nextRoad || act.currentRoad;
      if (!road) continue;
      let d = act.length || 0;
      if (d < 1 && act.offset != null) {
        const actEnd = actions[i + 1]?.offset ?? pts.length - 1;
        const si = Math.min(act.offset, cumDist.length - 1);
        const ei = Math.min(actEnd, cumDist.length - 1);
        d = Math.max(0, cumDist[ei] - cumDist[si]);
      }
      if (d < 1 && (act.duration || 0) > 0) d = act.duration * 14;
      if (d < 1) continue;
      const dur = act.duration || Math.round(d / 14); // seconds estimated
      const ref  = (road.number || []).map(n => n.value).join(';');
      const rawName = (road.name   || []).map(n => n.value).join('/');
      // Extract fuller road name from instruction text (e.g. "Follow Autoestrada do Norte / A1 / E80")
      const instruction = act.instruction || act.action || '';
      let name = rawName;
      if (ref && !rawName && instruction) {
        // Try to extract road name from instruction: "Seguir pela Autoestrada do Norte A1"
        const match = instruction.match(/(?:pela|por|na|onto|on|via)\s+(.+?)(?:\s+para\s|\s+towards\s|\s+em\s|\.|$)/i);
        if (match) {
          const extracted = match[1].replace(new RegExp(ref.replace(/[;/]/g, '|'), 'g'), '').trim().replace(/^[\/\s-]+|[\/\s-]+$/g, '');
          if (extracted.length > 2) name = extracted;
        }
      }
      const stepLabel = ref || name || 'Sem nome';
      const type = classifyRoad(stepLabel);
      const country = sectionCountry;
      if (prev && prev.label === stepLabel) {
        prev.distance += d;
        prev.duration = (prev.duration || 0) + dur;
      } else {
        prev = { label: stepLabel, ref, name, type, distance: d, duration: dur, instruction, country };
        steps.push(prev);
      }
    }
  }

  return {
    distance: dist,
    duration: dur,
    geometry: { type: 'LineString', coordinates: coords },
    legs: sections,
    roadBreakdown: breakdown,
    countryDistances,
    routeSteps: steps,
    roadSegments,
  };
}

export async function calculateRouteHERE(origin, destination, waypoints = [], options = {}) {
  if (!HERE_KEY || HERE_KEY.includes('SUA_KEY')) {
    throw new Error('Token HERE não configurado. Adiciona REACT_APP_HERE_TOKEN ao .env');
  }

  const isHgv = options.vehicleType !== 'car';

  function buildUrl(opts) {
    const p = [
      `transportMode=${isHgv ? 'truck' : 'car'}`,
      `origin=${origin[1]},${origin[0]}`,
      `destination=${destination[1]},${destination[0]}`,
      'return=polyline,summary,turnByTurnActions,actions',
      'spans=countryCode,names,functionalClass',
      `departureTime=${opts.departureTime ? new Date(opts.departureTime).toISOString() : new Date().toISOString()}`,
      // apikey NÃO vai aqui — é injectada pelo backend (proxy /routing/here-route).
    ];

    for (const wp of waypoints) p.push(`via=${wp[1]},${wp[0]}`);

    if (opts.alternatives) p.push(`alternatives=${typeof opts.alternatives === 'number' ? opts.alternatives : 2}`);

    const feats = [];
    if (opts.avoidTolls)     feats.push('tollRoad');
    if (opts.avoidFerries)   feats.push('ferry');
    if (opts.avoidMotorways) feats.push('controlledAccessHighway');
    if (opts.avoidTunnels)   feats.push('tunnel');
    if (feats.length)        p.push(`avoid[features]=${feats.join(',')}`);

    for (const city of (opts.avoidUrbanAreas || [])) {
      const ring = URBAN_AREAS[city];
      if (!ring) continue;
      const lngs = ring.map(c => c[0]);
      const lats = ring.map(c => c[1]);
      p.push(`avoid[areas]=bbox:${Math.min(...lngs)},${Math.min(...lats)},${Math.max(...lngs)},${Math.max(...lats)}`);
    }

    // BBoxes arbitrárias para evitar — usado pelo botão "Recalcular evitando"
    // sobre incidentes (acidentes/cortes). Formato esperado: array de
    // { west, south, east, north } em graus.
    for (const bb of (opts.avoidAreaBboxes || [])) {
      if (bb && typeof bb.west === 'number' && typeof bb.south === 'number'
        && typeof bb.east === 'number' && typeof bb.north === 'number') {
        p.push(`avoid[areas]=bbox:${bb.west},${bb.south},${bb.east},${bb.north}`);
      }
    }

    // Avoid Low Emission Zones (LEZ) — real regulated zones in European cities
    if (opts.avoidLEZ) {
      p.push('avoid[zoneCategories]=environmental');
    }

    if (isHgv) {
      if (opts.truckWeight)   p.push(`truck[grossWeight]=${Math.round(Number(opts.truckWeight) * 1000)}`);
      if (opts.truckAxleLoad) p.push(`truck[axleWeight]=${Math.round(Number(opts.truckAxleLoad) * 1000)}`);
      if (opts.truckHeight)   p.push(`truck[height]=${Math.round(Number(opts.truckHeight) * 100)}`);
      if (opts.truckWidth)    p.push(`truck[width]=${Math.round(Number(opts.truckWidth) * 100)}`);
      if (opts.truckLength)   p.push(`truck[length]=${Math.round(Number(opts.truckLength) * 100)}`);
    }

    // Devolve SÓ a query string — o pedido HTTP é feito pelo backend (proxy).
    return p.join('&');
  }

  // Calcula a rota através do PROXY do backend (/planner-api/routing/here-route):
  // servidor na Europa → latência ~0,2s por chamada (vs ~1,5s do browser em
  // Angola) e a apikey do HERE fica escondida no servidor.
  async function doFetch(query) {
    const token = (() => { try { return sessionStorage.getItem('planner_token'); } catch { return null; } })();
    const res = await fetch('/planner-api/routing/here-route', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify({ query }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(
        err.cause || err.title || err.error || `HERE API error ${res.status}: verifique as coordenadas e o token`
      );
    }
    return res.json();
  }

  // UMA chamada ao proxy — as retentativas (sem alternativas / sem áreas
  // evitadas) são feitas SERVER-SIDE (rápidas, Europa→HERE). O backend
  // sinaliza o fallback de polígono via `_polygonFallback`.
  const data = await doFetch(buildUrl(options));
  const polygonFallback = !!data._polygonFallback;

  if (!data.routes || data.routes.length === 0) {
    throw new Error('Nenhuma rota encontrada entre os pontos indicados');
  }

  const [main, ...alts] = data.routes;
  return {
    route: parseSections(main.sections),
    alternatives: alts.map(r => parseSections(r.sections)),
    warning: polygonFallback
      ? 'Não foi possível desviar os centros urbanos selecionados. A rota apresentada pode passar por essas áreas.'
      : null,
  };
}

// ── Traffic Incidents along route ──────────────────────────────────

const INCIDENT_TYPE_MAP = {
  0: { label: 'Acidente', labelEn: 'Accident', emoji: '🚨', color: '#ef4444' },
  1: { label: 'Congestionamento', labelEn: 'Congestion', emoji: '🟠', color: '#f97316' },
  2: { label: 'Obras', labelEn: 'Road Works', emoji: '🚧', color: '#eab308' },
  3: { label: 'Estrada Cortada', labelEn: 'Road Closed', emoji: '⛔', color: '#dc2626' },
  4: { label: 'Outros', labelEn: 'Other', emoji: '⚠️', color: '#6b7280' },
};

export { INCIDENT_TYPE_MAP };

/**
 * Fetch a full travel-time + distance matrix from HERE Matrix Routing v8 (sync mode).
 * Sync mode has a 15 × 15 limit — callers should split or fall back for larger sets.
 *
 * @param {Array<{lat:number,lng:number}>} points  — list of unique stops
 * @param {Object} options  — same shape as calculateRouteHERE (vehicleType, truckWeight, avoid*)
 * @returns {{ travelTimes: number[][], distances: number[][] }}  seconds + metres, row = origin i, col = dest j
 */
export async function fetchTravelMatrix(points, options = {}) {
  if (!HERE_KEY || HERE_KEY.includes('SUA_KEY')) {
    throw new Error('Token HERE não configurado');
  }
  if (!Array.isArray(points) || points.length < 2) {
    throw new Error('Matriz requer pelo menos 2 pontos');
  }
  if (points.length > 15) {
    throw new Error(`Matriz síncrona HERE limitada a 15 pontos (pedidos: ${points.length})`);
  }

  const isTruck = options.vehicleType !== 'car';
  const body = {
    origins: points.map(p => ({ lat: Number(p.lat), lng: Number(p.lng) })),
    destinations: points.map(p => ({ lat: Number(p.lat), lng: Number(p.lng) })),
    // autoCircle wraps all points with a radial margin — required for sync mode.
    // margin 50 km. Anything bigger pushes total diameter above HERE's sync limit (400 km)
    // for routes spanning more than ~250 km between extremes (e.g. Porto ↔ Lisboa).
    regionDefinition: { type: 'autoCircle', margin: 50000 },
    matrixAttributes: ['travelTimes', 'distances'],
    transportMode: isTruck ? 'truck' : 'car',
    routingMode: 'fast',
  };

  if (options.departureTime) {
    body.departureTime = new Date(options.departureTime).toISOString();
  }

  // Avoid features (Matrix API uses a slightly different shape than Routing API)
  const avoidFeatures = [];
  if (options.avoidTolls)     avoidFeatures.push('tollRoad');
  if (options.avoidFerries)   avoidFeatures.push('ferry');
  if (options.avoidMotorways) avoidFeatures.push('controlledAccessHighway');
  if (options.avoidTunnels)   avoidFeatures.push('tunnel');
  if (avoidFeatures.length) body.avoid = { features: avoidFeatures };

  if (isTruck) {
    body.truck = {};
    if (options.truckWeight)   body.truck.grossWeight = Math.round(Number(options.truckWeight) * 1000);
    if (options.truckAxleLoad) body.truck.axleWeight  = Math.round(Number(options.truckAxleLoad) * 1000);
    if (options.truckHeight)   body.truck.height      = Math.round(Number(options.truckHeight) * 100);
    if (options.truckWidth)    body.truck.width       = Math.round(Number(options.truckWidth) * 100);
    if (options.truckLength)   body.truck.length      = Math.round(Number(options.truckLength) * 100);
  }

  const url = `https://matrix.router.hereapi.com/v8/matrix?async=false&apikey=${HERE_KEY}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.cause || err.title || `HERE Matrix error ${res.status}`);
  }
  const data = await res.json();
  const n = points.length;
  const flatT = data.matrix?.travelTimes || [];
  const flatD = data.matrix?.distances || [];
  const travelTimes = Array.from({ length: n }, (_, i) =>
    Array.from({ length: n }, (_, j) => flatT[i * n + j] ?? 0)
  );
  const distances = Array.from({ length: n }, (_, i) =>
    Array.from({ length: n }, (_, j) => flatD[i * n + j] ?? 0)
  );
  return { travelTimes, distances };
}

function getBboxFromCoords(coords, paddingDeg = 0.08) {
  let minLng = Infinity, minLat = Infinity, maxLng = -Infinity, maxLat = -Infinity;
  for (const [lng, lat] of coords) {
    if (lng < minLng) minLng = lng;
    if (lat < minLat) minLat = lat;
    if (lng > maxLng) maxLng = lng;
    if (lat > maxLat) maxLat = lat;
  }
  return { south: minLat - paddingDeg, west: minLng - paddingDeg, north: maxLat + paddingDeg, east: maxLng + paddingDeg };
}

function sampleRouteCoords(coords, step = 20) {
  const sampled = [coords[0]];
  for (let i = step; i < coords.length; i += step) sampled.push(coords[i]);
  sampled.push(coords[coords.length - 1]);
  return sampled;
}

function haversine([lng1, lat1], [lng2, lat2]) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function distToRoute(point, routeSampled) {
  let min = Infinity;
  for (const rp of routeSampled) {
    const d = haversine(point, rp);
    if (d < min) min = d;
  }
  return min;
}

// Split route bbox into grid cells that don't exceed 0.9 degrees (HERE API limit is 1 degree)
function splitRouteBboxes(routeCoords, maxDeg = 0.9) {
  const fullBbox = getBboxFromCoords(routeCoords);
  const spanLat = fullBbox.north - fullBbox.south;
  const spanLng = fullBbox.east - fullBbox.west;
  if (spanLat <= maxDeg && spanLng <= maxDeg) return [fullBbox];

  // Grid approach: divide full bbox into cells, keep only cells that have route coords
  const stepsLat = Math.ceil(spanLat / maxDeg);
  const stepsLng = Math.ceil(spanLng / maxDeg);
  const cellLat = spanLat / stepsLat;
  const cellLng = spanLng / stepsLng;

  // Sample route to check which cells have points (every 20th coord)
  const step = Math.max(1, Math.floor(routeCoords.length / 500));
  const occupiedCells = new Set();
  for (let i = 0; i < routeCoords.length; i += step) {
    const [lng, lat] = routeCoords[i];
    const ci = Math.min(Math.floor((lng - fullBbox.west) / cellLng), stepsLng - 1);
    const ri = Math.min(Math.floor((lat - fullBbox.south) / cellLat), stepsLat - 1);
    occupiedCells.add(`${ri}-${ci}`);
  }

  const bboxes = [];
  for (const key of occupiedCells) {
    const [ri, ci] = key.split('-').map(Number);
    bboxes.push({
      south: fullBbox.south + ri * cellLat,
      north: fullBbox.south + (ri + 1) * cellLat,
      west: fullBbox.west + ci * cellLng,
      east: fullBbox.west + (ci + 1) * cellLng,
    });
  }
  // Limit to max 10 cells to avoid too many requests
  return bboxes.slice(0, 10);
}

async function fetchIncidentsForBbox(bbox) {
  const url = `https://data.traffic.hereapi.com/v7/incidents?` +
    `in=bbox:${bbox.west},${bbox.south},${bbox.east},${bbox.north}` +
    `&locationReferencing=shape` +
    `&apiKey=${HERE_KEY}`;
  try {
    const res = await fetch(url);
    if (!res.ok) return [];
    const data = await res.json();
    return data.results || [];
  } catch { return []; }
}

// Public wrapper used by the map's "Mostrar incidentes" toggle. Accepts
// a Google LatLngBounds (or any object with .toJSON() returning
// {north,east,south,west}) and returns the same shape as
// fetchTrafficIncidents() — but for the whole viewport, not constrained
// to a route corridor.
export async function fetchIncidentsForViewport(bounds) {
  if (!HERE_KEY || !bounds) return [];
  const j = typeof bounds.toJSON === 'function' ? bounds.toJSON() : bounds;
  if (j.north == null || j.south == null || j.east == null || j.west == null) return [];
  const results = await fetchIncidentsForBbox({
    north: j.north, south: j.south, east: j.east, west: j.west,
  });
  const incidents = [];
  const seenIds = new Set();
  for (const item of results) {
    const loc = item.location;
    if (!loc || !loc.shape) continue;
    const shapePoint = loc.shape.links?.[0]?.points?.[0] || null;
    if (!shapePoint) continue;
    const id = item.incidentDetails?.id || `${shapePoint.lat}-${shapePoint.lng}`;
    if (seenIds.has(id)) continue;
    seenIds.add(id);
    const d = item.incidentDetails || {};
    // HERE Traffic v7 returns the type as a camelCase string. Normalise
    // case-insensitively so we don't fall through to "Outros" for every
    // incident — and keep matches for hypothetical SCREAMING_SNAKE_CASE.
    const t = String(d.type || '').toLowerCase().replace(/_/g, '');
    const typeCode = t === 'accident' ? 0
      : (t === 'congestion' || t === 'jam') ? 1
      : (t === 'construction' || t === 'roadworks' || t === 'roadhazard') ? 2
      : (t === 'roadclosure' || d.roadClosed === true) ? 3 : 4;
    incidents.push({
      id,
      type: typeCode,
      typeName: INCIDENT_TYPE_MAP[typeCode],
      description: d.description?.value || INCIDENT_TYPE_MAP[typeCode].label,
      summary: d.summary?.value || null,
      criticality: d.criticality || null,
      roadClosed: d.roadClosed || false,
      coordinates: [shapePoint.lng, shapePoint.lat],
      startTime: d.startTime,
      endTime: d.endTime,
      lastUpdated: item.sourceUpdated || null,
    });
  }
  return incidents;
}

export async function fetchTrafficIncidents(routeCoords, maxDistKm = 8) {
  if (!HERE_KEY) return [];

  const bboxes = splitRouteBboxes(routeCoords);
  const allResults = await Promise.all(bboxes.map(fetchIncidentsForBbox));
  const results = allResults.flat();
  if (!results.length) return [];

  const sampled = sampleRouteCoords(routeCoords);
  const incidents = [];
  const seenIds = new Set();

  for (const item of results) {
    const loc = item.location;
    if (!loc || !loc.shape) continue;

    const shapePoint = loc.shape.links?.[0]?.points?.[0] || null;
    if (!shapePoint) continue;

    const incId = item.incidentDetails?.id || `${shapePoint.lat}-${shapePoint.lng}`;
    if (seenIds.has(incId)) continue;
    seenIds.add(incId);

    const coord = [shapePoint.lng, shapePoint.lat];
    const dist = distToRoute(coord, sampled);
    if (dist > maxDistKm) continue;

    const incidentDetails = item.incidentDetails || {};
    const t = String(incidentDetails.type || '').toLowerCase().replace(/_/g, '');
    const typeCode = t === 'accident' ? 0
      : (t === 'congestion' || t === 'jam') ? 1
      : (t === 'construction' || t === 'roadworks' || t === 'roadhazard') ? 2
      : (t === 'roadclosure' || incidentDetails.roadClosed === true) ? 3 : 4;

    incidents.push({
      id: incId,
      type: typeCode,
      typeName: INCIDENT_TYPE_MAP[typeCode],
      description: incidentDetails.description?.value || INCIDENT_TYPE_MAP[typeCode].label,
      coordinates: coord,
      startTime: incidentDetails.startTime,
      endTime: incidentDetails.endTime,
      distKm: Math.round(dist * 10) / 10,
    });
  }

  return incidents;
}
